/* eslint-disable import/prefer-default-export */
import { ref } from 'vue';
import { defineStore } from 'pinia';
import useLocalStorage from '@/composables/storage/useLocalStorage';
import filters from '@/composables/store/filters';
import useFormValidation from '@/composables/validations/useFormValidation';
import useGlobalActions from '@/composables/store/globalActions';

const { bindLocalStorage } = useLocalStorage();
const {
  validateFullNameField,
  validateDobField,
  validateCheckboxField,
  validateAddressLine1Field,
} = useFormValidation();
const { formHasErrors, getErrorByField } = filters();
const { updateErrorFieldByKey } = useGlobalActions();

const formObject = ref({
  fullName: {
    value: null,
    error: null,
    required: true,
    validator: validateFullNameField,
  },
  dob: {
    value: null,
    error: null,
    required: true,
    validator: validateDobField,
  },
  addressLine1: {
    value: null,
    required: true,
    error: null,
    validator: validateAddressLine1Field,
  },
  suburb: {
    value: null,
    required: true,
  },
  state: {
    value: null,
    required: true,
  },
  postcode: {
    value: null,
    required: true,
  },
  country: {
    value: null,
    required: true,
  },
  zerohash_tnc: {
    value: false,
    required: false,
    error: null,
    validator: validateCheckboxField,
  },
});

export const useIdentityConfirmationStore = defineStore({
  id: 'identityConfirmation',
  state: () => ({
    form: formObject,
    personalDetails: {},
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
    getPersonalDetails: (store) => store.personalDetails,
    getCountry: (store) => store.form.country.value,
    getGivenName: (store) => store.form.fullName.value?.split(' ')[0] || '',
  },
  actions: {
    updateValue(field, val) {
      if (Object.getOwnPropertyDescriptor(this.form[field], 'validator')) {
        const { validator } = this.form[field];

        this.form[field].error = validator(field, val);
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
    updateRequiredFieldForKey(field, isRequired) {
      if (
        !field
        || !Object.getOwnPropertyDescriptor(this.form, field)
        || !Object.getOwnPropertyDescriptor(this.form[field], 'required')
      ) {
        return;
      }

      this.form[field].required = isRequired;
    },
    setPersonalDetails(personalDetails) {
      this.personalDetails = personalDetails;
    },
    updateErrorFieldByKey(field, error) {
      updateErrorFieldByKey(this.form, field, error);
    },
  },
});
